import { render, staticRenderFns } from "./policy-yuri-list.vue?vue&type=template&id=44fffd56&scoped=true&"
import script from "./policy-yuri-list.vue?vue&type=script&lang=js&"
export * from "./policy-yuri-list.vue?vue&type=script&lang=js&"
import style0 from "./policy-yuri-list.vue?vue&type=style&index=0&id=44fffd56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fffd56",
  null
  
)

export default component.exports